import { ClipboardEvent } from "react";

export const removeBGColorOnCopy = (event: ClipboardEvent) => {
  event.preventDefault(); // prevent the browser from doing the normal copy

  const selection = window.getSelection();
  if (!selection || selection.isCollapsed) {
    return; // nothing to copy
  }

  const container = document.createElement("div");
  for (let i = 0; i < selection.rangeCount; i += 1) {
    container.appendChild(selection.getRangeAt(i).cloneContents());
  }

  // Remove background color styles
  container.querySelectorAll<HTMLElement>("*").forEach((el) => {
    if (el.style.backgroundColor) {
      // eslint-disable-next-line no-param-reassign
      el.style.backgroundColor = "";
    }

    if (el.hasAttribute("style") && el.getAttribute("style")?.includes("background")) {
      const cleaned = el
        .getAttribute("style")!
        .split(";")
        .filter((style) => !style.trim().startsWith("background"))
        .join(";");
      if (cleaned.trim()) {
        el.setAttribute("style", cleaned);
      } else {
        el.removeAttribute("style");
      }
    }
  });

  event.clipboardData?.setData("text/html", container.innerHTML);
  event.clipboardData?.setData("text/plain", container.innerText);
};
